// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2lwD9","loaderOuter":"PageOverlayLoader_loaderOuter__wCi4s"};